<template>
  <layout-content>
    <stats-detailed />
  </layout-content>
</template>

<script>
  import StatsDetailed from '@autocaller_v2/components/campaigns-stats-detailed';

  export default {
    components: { StatsDetailed },
  };
</script>
